(() => {
  function init(root = document) {
    root.querySelectorAll('[data-sb-shop]').forEach(shop => {
      if (shop.dataset.ready) return;
      shop.dataset.ready = 'true';
      const main = shop.querySelector('[data-sb-main]');
      const buttons = [...shop.querySelectorAll('[data-sb-photo]')];
      buttons.forEach(button => button.addEventListener('click', () => {
        main.src = button.dataset.sbPhoto;
        main.alt = button.querySelector('img').alt;
        buttons.forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      }));
      const select = shop.querySelector('[data-sb-variant]');
      if (!select) return;
      const update = () => {
        const option = select.selectedOptions[0];
        shop.querySelector('[data-sb-price]').textContent = option.dataset.price;
        const stickyPrice = shop.querySelector('[data-sb-sticky-price]');
        if (stickyPrice) stickyPrice.textContent = option.dataset.price;
        const add = shop.querySelector('[data-sb-add]');
        add.disabled = option.dataset.available !== 'true';
        add.textContent = add.disabled ? 'Sold out' : 'Add to cart';
        if (option.dataset.photo) {
          main.src = option.dataset.photo;
          main.alt = option.textContent;
          buttons.forEach(b => b.setAttribute('aria-pressed', 'false'));
        }
      };
      select.addEventListener('change', update);
      const sticky = shop.querySelector('[data-sb-sticky]');
      const purchase = shop.querySelector('[data-sb-add]');
      shop.querySelector('[data-sb-return]')?.addEventListener('click', () => {
        select.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center'});
        select.focus({preventScroll: true});
      });
      if (sticky && purchase && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => {
          sticky.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
        });
        observer.observe(purchase);
        shop.addEventListener('shopify:section:unload', () => observer.disconnect(), {once: true});
      }
      // Respect an explicitly linked variant and its original product image.
      if (new URLSearchParams(location.search).has('variant')) update();
    });
    root.querySelectorAll('[data-sb-offer]').forEach(wrap => {
      if (wrap.dataset.ready) return;
      wrap.dataset.ready = 'true';
      const modal = wrap.querySelector('dialog');
      const form = wrap.querySelector('form');
      const opener = wrap.querySelector('[data-sb-open]');
      const pairButton = wrap.querySelector('[data-sb-add-pair]');
      pairButton?.addEventListener('click', async () => {
        if (pairButton.disabled) return;
        const status = wrap.querySelector('[data-sb-pair-status]');
        const selects = [...wrap.querySelectorAll('[data-sb-pair-variant]')];
        if (selects.length !== 2 || selects.some(s => !s.value)) return;
        pairButton.disabled = true;
        pairButton.textContent = 'Adding your bands…';
        status.textContent = '';
        const quantities = new Map();
        selects.forEach(s => quantities.set(s.value, (quantities.get(s.value) || 0) + 1));
        const root = wrap.dataset.root || '/';
        let added = false;
        try {
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST', credentials: 'same-origin',
            headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
            body: JSON.stringify({items: [...quantities].map(([id, quantity]) => ({id, quantity}))})
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || 'Could not add both bands. Check availability and try again.');
          added = true;
          pairButton.textContent = 'Bands added';
          status.textContent = 'Both bands are in your cart. Opening your cart with the code…';
          const link = wrap.querySelector('[data-sb-discount-link]');
          const destination = root + 'discount/' + encodeURIComponent(wrap.dataset.code) + '?redirect=' + encodeURIComponent(root + 'cart');
          link.href = destination;
          link.textContent = 'Open cart with code';
          location.assign(destination);
        } catch (error) {
          status.textContent = added ? 'Your bands were added. Use the link below to open your cart.' : (error.message || 'There was a connection problem. Check your cart before trying again.');
          // Do not re-add after a successful cart mutation if navigation fails.
          if (!added) { pairButton.disabled = false; pairButton.textContent = 'Add both bands'; }
        }
      });
      const key = 'scentband-offer-dismissed-v2';
      let previousFocus;
      const read = (storage, name) => { try { return storage.getItem(name); } catch { return null; } };
      const write = (storage, name, value) => { try { storage.setItem(name, value); } catch {} };
      const open = () => { if (!modal.open) { previousFocus = document.activeElement; modal.showModal(); } };
      const dismiss = () => { modal.close(); };
      opener.addEventListener('click', open);
      modal.querySelectorAll('[data-sb-close]').forEach(b => b.addEventListener('click', dismiss));
      modal.addEventListener('click', e => { if (e.target === modal) { const r = modal.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dismiss(); } });
      modal.addEventListener('close', () => { write(localStorage, key, String(Date.now())); previousFocus?.focus(); });
      if (form) {
        form.action = form.action.split('#')[0] + '#sb-offer';
        const phone = form.querySelector('input[type=tel]');
        phone?.addEventListener('input', () => {
          const digits = phone.value.replace(/\D/g, '');
          phone.setCustomValidity(digits.length >= 7 && digits.length <= 15 ? '' : 'Enter a phone number with 7 to 15 digits, including country code.');
        });
        form.addEventListener('submit', () => write(sessionStorage, 'sb-offer-pending', String(Date.now())));
      }
      const pending = Number(read(sessionStorage, 'sb-offer-pending'));
      const ours = location.hash === '#sb-offer' || (pending && Date.now() - pending < 600000);
      if (ours && (wrap.querySelector('[data-sb-success]') || wrap.querySelector('[data-sb-errors]'))) {
        open();
        if (wrap.querySelector('[data-sb-success]')) { write(localStorage, key, String(Date.now())); write(sessionStorage, 'sb-offer-pending', '0'); }
      } else if (wrap.dataset.design === 'true') {
        open();
      } else if (Date.now() - Number(read(localStorage, key) || 0) > 604800000) {
        setTimeout(() => { if (!document.querySelector('dialog[open]') && !/INPUT|SELECT|TEXTAREA/.test(document.activeElement.tagName)) open(); }, Number(wrap.dataset.delay) * 1000);
      }
    });
  }
  init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
